import React, { useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { useLocation } from 'react-router-dom';
import * as XLSX from "xlsx";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import { Modal, Button, Form } from "react-bootstrap";
import uploadAndDownloadService from "../../../services/uploadAndDownloadFile";
import UploadBcSellFile from "../../../ui/UploadBcSellFile";
import SellingService from "../../../services/SellingService";
import UtilsFormule from "../../../utils/UtilsFormule";
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import toastr from "toastr";
const BDCNonConfirme = ({ listBDC, change }) => {
  const navigate = useNavigate();
  const location = useLocation();
  console.log("listBDC", listBDC);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showModalAdd, setShowModalAdd] = useState(false);
  const [selectedReference, setSelectedReference] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [newCreationDate, setNewCreationDate] = useState("");
  const [bonReception, setBonReception] = useState("");
  const [showModalAddNew, setShowModalAddNew] = useState(false);



  // Open modal and set reference and current creation date
  const handleOpenModal = (reference, creationDate) => {
    setSelectedReference(reference);
    const date = new Date(creationDate);
    const formattedDate = date.toISOString().replace('T', ' ').slice(0, 19).replace(/ /g, 'T');
    setNewCreationDate(formattedDate);
    setShowModal(true);
  };
  // Open modal and set reference and current creation date
  const handleOpenModalAdd = (reference, id, returnToSociete) => {
    setSelectedReference(reference);
    setSelectedId(id);
    if (returnToSociete === "yes") {
      setSelectedOption("yes")
    }
    setShowModalAdd(true);
  };
  // Open modal and set reference and current creation date
  const handleOpenNewModal = (reference, id) => {
    setSelectedReference(reference);
    setSelectedId(id);
    setShowModalAddNew(true);
  };
  // Close modal
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReference(null);
    setNewCreationDate("");
  };
  // Close modal
  const handleCloseModalAdd = () => {
    setShowModalAdd(false);

  };
  const handleCloseModalAddNew = () => {
    setShowModalAddNew(false);

  };
  // Save new creation date logic
  const handleSaveDate = () => {
    // console.log("Saving new date:", `${newCreationDate}`, "for reference:", selectedReference);
    SellingService.updateBonCommandeSaleCreationDate(getCurrentUserId(), selectedReference, newCreationDate)
      .then((response) => {
        toastr.success("Bon de commande mis à jour avec succès")
        setShowModal(false);
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setShowModal(false);
        toastr.error("Erreur lors de la mise à jour du bon de commande");
      });
  };
  const handleSaveBonReception = () => {
    const data = {
      idBDC: selectedId,
      idUser: getCurrentUserId(),
      refReception: bonReception
    }
    SellingService.addRefReceptionToBonCommandeSale(data)
      .then((response) => {
        toastr.success("Référence Bon Réception Ajouter avec succès")
        setShowModalAdd(false);
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setShowModalAdd(false);
        toastr.error("Erreur lors de la mise à jour du bon de commande");
      });
  };
  // const [clients, setClients] = useState(listBDC);
  // const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  // const [inConfirmedDevis, setInConfirmedDevis] = useState([]);
  const [inConfirmedBdc, setInConfirmedBdc] = useState([]);
  const [archivedBdc, setArchivedBdc] = useState([]);
  const [bdcRelatedToInvoice, setBdcRelatedToInvoice] = useState([]);
  const [selectedOption, setSelectedOption] = useState("no");

  // Define the function to handle radio button changes
  const handleOptionChange = (value) => {
    setSelectedOption(value); // Update the selected option in state
    console.log("Selected Option:", value); // Optional: Log the selected value
  };
  const [bdcUploadInformation, setBdcUploadInformation] = useState({
    reference: "any",
    state: 0,
    inConfirmedBdc: inConfirmedBdc,
  });
  const [onUploadFile, setOnUploadFile] = useState(false);

  const { SearchBar } = Search;
  const fmt = (v) => v != null ? parseFloat(Number(v).toFixed(3)) : "";
  const MyExportExcel = () => {
    const handleExport = () => {
      const rows = listBDC.map((row) => ({
        "Réf":        row.reference,
        "Client":     row.title,
        "Prix.V.HT":  fmt(row.buyingPrice),
        "Prix.V.TT":  fmt(row.ttPrice),
        "TVA":        fmt(Number(row.ttPrice) - Number(row.buyingPrice)),
      }));
      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "BDC Vente");
      XLSX.writeFile(wb, `bons_commande_vente_${new Date().toISOString().split("T")[0]}.xlsx`);
    };
    return (
      <div>
        <button className="btn btn-dark" onClick={handleExport}>
          <i className="fas fa-file-excel"></i> Télécharger Excel
        </button>
      </div>
    );
  };

  const onArchiveHandler = (refDocument, isDeleted) => {
    SellingService.deleteAndRestoreBDC(refDocument, isDeleted)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          window.location.reload(false);
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : il ya un probléme de connection");
      });
  };

  function buttonDeleteFormatter(cell, row) {
    return (
      <div style={{ display: 'flex', gap: '8px' }}>
        <button
          style={{ width: 30 }}
          className="btn btn-danger btn-sm"
          onClick={() => onArchiveHandler(row.reference, 1)}
        >
          <i className="fas fa-trash"></i>
        </button>
        <button
          style={{ width: 30 }}
          className="btn btn-warning btn-sm"
          onClick={() => {
            console.log("row-------------------------------------->", row)
            handleOpenModal(row.reference, row.creationDate)
          }
          }
        >
          <i className="fas fa-edit"></i>
        </button>
        {
          row.stateLivraison === 2 &&
          <button
            style={{ width: 30 }}
            className="btn btn-success btn-sm"
            onClick={() => {
              // console.log("Row data: ", row);
              handleOpenModalAdd(row.reference, row.id, row?.return_to_societe);
            }}
          >
            <i className="fas fa-plus"></i>
          </button>

        }
        <button
          style={{ width: 30 }}
          className="btn btn-primary btn-sm"
          onClick={() => {
            console.log("Row data: ", row);
            handleOpenNewModal(row.reference, row.id);
          }}
        >
          <i className="fas fa-plus"></i>
        </button>
      </div>
    );
  }


  // const onUploadFileHandler = (state, reference, isDeleted) => {
  //   setBdcUploadInformation({
  //     inConfirmedBdc: [],
  //     reference: reference,
  //     state: state,
  //   });

  //   setOnUploadFile({
  //     reference: reference,
  //     state: state,
  //     index: 0,
  //     bdcData: inConfirmedBdc,
  //     isDeleted: 0,
  //   });

  //   setOnUploadFile(true);
  // };
  // const onUploadFileHandler = (state, reference, index, isDeleted) => {
  //   setBdcUploadInformation({
  //     inConfirmedBdc: [],
  //     reference: reference,
  //     state: state,
  //   });
  //   if (isDeleted === 0) {
  //     if (state === 0) {
  //       setOnUploadFile({
  //         reference: reference,
  //         state: state,
  //         index: index,
  //         bdcData: listBDC,
  //         isDeleted: 0,
  //       });
  //     } else if (state === 1) {
  //       setOnUploadFile({
  //         reference: reference,
  //         state: state,
  //         index: index,
  //         bdcData: bdcRelatedToInvoice,
  //         isDeleted: 0,
  //       });
  //     }
  //   } else {
  //     setOnUploadFile({
  //       reference: reference,
  //       state: state,
  //       index: index,
  //       bdcData: archivedBdc,
  //       isDeleted: 1,
  //     });
  //   }

  //   setOnUploadFile(true);
  // };
  // function buttonFileFormatter(cell, row) {
  //   if (row.path !== null && row.path !== "string" && row.path !== "any") {
  //     return (
  //       <button
  //         style={{ width: 40 }}
  //         class="btn bg-gray btn-sm "
  //         onClick={() =>
  //           onShowFileInOtherWizndowHandler(
  //             // UtilsUrl.sellingFileURL() +
  //             row.path
  //           )
  //         }
  //       >
  //         <i class="fas fa-eye"></i>
  //       </button>
  //     );
  //   } else {
  //     return (
  //       <span>
  //         <button
  //           style={{ width: 40 }}
  //           class="btn bg-gray btn-sm text-center"
  //           onClick={() =>
  //             onUploadFileHandler(row.state, row.reference, row.isDeleted)
  //           }
  //         >
  //           <i class="fas fa-plus"></i>
  //         </button>
  //       </span>
  //     );
  //   }
  // }

  const onViewFactureHistoriqueWarehousesHandler = (idDocument) => {
    sessionStorage.setItem("DocumentId", idDocument);
    sessionStorage.setItem("typeDocument", "BDCSell");
    const pdfWindow = window.open();
    pdfWindow.location.href = "/historiqueLivraison";
  };

  function buttonTypeCommandeFormatter(cell, row) {
    if (row.typeCommande === 0 || row.typeCommande === null) {
      return <>BDC</>;
    } else {
      return <>Commande</>;
    }
  }
  function buttonDevisFormatter(cell, row) {
    if (row.devisReference !== null) {
      return <span>{row.devisReference}</span>;
    } else {
      return (
        <span>
          <i class="fas fa-solid fa-ban"></i>
        </span>
      );
    }
  }


  function dateFormatter(cell, row) {
    return <span>{UtilsFormule.formatDateHours(row.creationDate)}</span>;

  }

  const onViewProductsHandler = (refDocument, NoteDocument) => {
    sessionStorage.setItem("refDocument", refDocument);
    sessionStorage.setItem("typeDocument", "bdc");
    const pdfWindow = window.open();
    pdfWindow.location.href = location.pathname.includes('ModifierBonCommandeVente') ? "/EditDocumentSalesByRef" : "/getDocumentSalesByRef";
    // navigate("/getDocumentSalesByRef");
  };

  function buttonDetailsFormatter(cell, row) {
    return (
      <>
          <button
            style={{ width: 40 }}
            class="btn bg-black btn-sm "
            onClick={() => onViewProductsHandler(row.reference, row.note)}
          >
            {location.pathname.includes('ModifierBonCommandeVente')  ? <i class="fas fa-edit"></i> : <i class="fas fa-shopping-cart"></i>}
          </button>
      </>

    );
  }
  const handelUpdateEtat = () => {
    SellingService.changeVarReturnToSocieteInBonCommandesSale(getCurrentUserId(), selectedId, selectedOption)
      .then((response) => {
        setShowModalAddNew(false);
        toastr.success("L'état du Bon de Commande a été modifié avec succès.");
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });

  }
  const onValidateDevisHandler = (ref) => {
    sessionStorage.setItem("refBDC", ref);
    // sessionStorage.setItem("typeToTax", "Devis");
    navigate("/validateBDCFactureVente");
  };
  function buttonValidateFormatter(cell, row) {
    return (
      <button
        style={{ width: 40 }}
        class="btn btn-dark btn-sm"
        onClick={() => onValidateDevisHandler(row.reference)}
      >
        <i class="fas fa-check"></i>
      </button>
    );
  }
  function buttonLivraisonFormatter(cell, row) {
    if (cell === 0) {
      return (
        <span style={{ cursor: "pointer" }} className="badge bg-warning">
          En attente
        </span>
      );
    } else if (cell === 1) {
      return (
        <a
          onClick={() => {
            onViewFactureHistoriqueWarehousesHandler(row.id);
          }}
        >
          <span style={{ cursor: "pointer" }} className="badge bg-primary">
            En cours
          </span>{" "}
        </a>
      );
    } else if (cell === 2) {
      return (
        <a
          onClick={() => {
            onViewFactureHistoriqueWarehousesHandler(row.id);
          }}
        >
          <span style={{ cursor: "pointer" }} className="badge bg-success">
            Terminé
          </span>{" "}
        </a>
      );
    } else if (cell === 3) {
      return (
        <a
          onClick={() => {
            onViewFactureHistoriqueWarehousesHandler(row.id);
          }}
        >
          <span style={{ cursor: "pointer" }} className="badge bg-success">
            Livré
          </span>{" "}
        </a>
      );
    }
  }
  const selectOptions = [
    { value: 0, label: 'En attente' },
    { value: 1, label: 'En cours' },
    { value: 2, label: 'Terminé' },
    { value: 3, label: 'Livré' }
  ];

  const columns = [
    {
      dataField: "reference",
      text: "Réf",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "9%" };
      },
    },
    {
      dataField: "title",
      text: "Client",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "13%" };
      },
    },
    {
      dataField: "note",
      text: "Note",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "creationDate",
      text: "DC",
      align: "center",
      formatter: dateFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "estimatedDeliveryDate",
      text: "Livraison estimée",
      align: "center",
      formatter: (cell, row) =>
        row.estimatedDeliveryDate ? (
          <span>
            {new Date(row.estimatedDeliveryDate).toLocaleDateString("fr-FR")}
          </span>
        ) : (
          <span className="text-muted">-</span>
        ),
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "buyingPrice",
      text: "P.V.HT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "9%" };
      },
    },
    {
      dataField: "ttPrice",
      text: "P.V.TT",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "9%" };
      },
    },
    {
      dataField: "devisReference",
      text: "Devis",
      align: "center",
      formatter: buttonDevisFormatter,
      headerAlign: "center",
      headerStyle: () => {
        return { width: "7%" };
      },
    },

    {
      dataField: "typeCommande",
      text: "Type",
      formatter: buttonTypeCommandeFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "9%" };
      },
    },
    {
      dataField: "stateLivraison",
      text: "",
      formatter: buttonLivraisonFormatter,
      // formatter: cell => selectOptions.filter(opt =>buttonLivraisonFormatter(cell))[0] || '',

      align: "center",
      headerAlign: "center",
      filter: selectFilter({
        options: selectOptions
      }),
      headerStyle: () => {
        return { width: "9%" };
      },

    },

    {
      dataField: "state",
      text: location.pathname.includes('ModifierBonCommandeVente') ? "Modifier" : "Info",
      formatter: buttonDetailsFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "7%" };
      },
    },
    {
      dataField: "isDeleted",
      text: "Action",
      formatter: buttonDeleteFormatter,
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },

  ];

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  function handleTableChange({ clients }) {
    if (change) {
      return clients;
    }
  }
  const pageButtonRenderer = ({
    page,
    active,
    disable,
    title,
    onPageChange,
  }) => {
    const handleClick = (e) => {
      e.preventDefault();
      onPageChange(page);
    };
    const activeStyle = {};
    if (active) {
      activeStyle.backgroundColor = "black";
      activeStyle.color = "white";
    } else {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    if (typeof page === "string") {
      activeStyle.backgroundColor = "white";
      activeStyle.color = "black";
    }
    return (
      <li className="page-item">
        <button
          className="btn btn-dark"
          onClick={handleClick}
          style={activeStyle}
        >
          {page}
        </button>
      </li>
    );
  };
  const options = {
    pageButtonRenderer,
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les bons de commandes de vente</h3>
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="id"
          data={listBDC}
          columns={columns}
          onTableChange={handleTableChange}
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  ></SearchBar>
                </div>
                <div className="ml-auto mr-0">
                  <MyExportExcel />
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  pagination={paginationFactory(options)}
                  striped
                  hover
                  condensed
                  filter={filterFactory()}

                />
              </div>
            </div>
          )}
        </ToolkitProvider>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}
      {onUploadFile && (
        <UploadBcSellFile
          setOnUploadFile={setOnUploadFile}
          setInConfirmedBdc={setInConfirmedBdc}
          setBDCRelatedToInvoice={setBdcRelatedToInvoice}
          bdcUploadInformation={bdcUploadInformation}
          setArchivedBdc={setArchivedBdc}
        />
      )}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Modifier la Date de Création</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p><strong>Référence du bon de commande:</strong> {selectedReference}</p>
          <Form.Group>
            <Form.Label>Modifier la Date de Création</Form.Label>
            <Form.Control
              type="datetime-local"
              value={newCreationDate}
              onChange={(e) => setNewCreationDate(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Annuler
          </Button>
          <Button variant="primary" onClick={handleSaveDate}>
            Enregistrer
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showModalAdd} onHide={handleCloseModalAdd}>
        <Modal.Header closeButton>
          <Modal.Title>Ajouter Référence Bon Réception</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p><strong>Référence du bon de commande:</strong> {selectedReference}</p>
          <Form.Group>
            <Form.Label>Ajouter Référence Bon Réception</Form.Label>
            <Form.Control
              type="text"
              value={bonReception}
              onChange={(e) => setBonReception(e.target.value)}
              className="form-control"
              placeholder="Enter Référence Bon Réception"

            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Annuler
          </Button>
          <Button variant="primary" onClick={handleSaveBonReception}>
            Enregistrer
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showModalAddNew} onHide={handleCloseModalAddNew}>
        <Modal.Header closeButton>
          <Modal.Title>Modifier l'État du Bon de Commande</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p><strong>Référence du bon de commande:</strong> {selectedReference}</p>
          <Form.Group style={{ marginBottom: "20px" }}>
            <div
              style={{
                display: "flex",
                padding: "10px",
                borderRadius: "8px",
                maxWidth: "60%",
                alignItems: "center",
              }}
            >
              <Form.Check
                type="checkbox"
                id="option1"
                name="options"
                value="yes"
                label="Oui"
                checked={selectedOption === "yes"} // Mark this checkbox as checked if selectedOption is "option1"
                onChange={() => handleOptionChange("yes")} // Update selectedOption to "option1"
                className="custom-checkbox"
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "20px",
                  fontSize: "1rem",
                }}
              />

              <Form.Check
                type="checkbox"
                id="option2"
                name="options"
                value="no"
                label="Non"
                checked={selectedOption === "no"} // Mark this checkbox as checked if selectedOption is "option2"
                onChange={() => handleOptionChange("no")} // Update selectedOption to "option2"
                className="custom-checkbox"
                style={{
                  fontSize: "1rem",
                  display: "flex",
                  alignItems: "center",
                }}
              />
            </div>
          </Form.Group>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModalAddNew}>
            Annuler
          </Button>
          <Button variant="primary" onClick={handelUpdateEtat}>
            Enregistrer
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
export default BDCNonConfirme;
